@if (selectedVacancy(); as vacancy) {
  <div class="layout py-16">
    <div class="flex justify-between items-center mb-4">
      <button class="text-sm flex gap-2 items-center" (click)="backToList()">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
             stroke="currentColor" class="size-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"/>
        </svg>
        <span>{{ 'seeAllVacancies' | translate }}</span>
      </button>
    </div>
    <div class="flex flex-col md:flex-row justify-between items-center">
      <div>
        <h2 class="font-bold mb-4 text-3xl leading-tight text-bleuCaliceo-300">
          {{ vacancy.title }}
        </h2>
        @if (vacancy.vacancy_id !== spontaneous()?.vacancy_id) {
          <div class="font-medium text-gray-500 text-base pb-4 flex flex-col md:flex-row gap-4">
            <div class="flex gap-4">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"/>
              </svg>
              <span>{{ vacancy.address.locality }}
                , {{ vacancy.address.postal_code }} {{ vacancy.address.country }}</span>
            </div>
            <div class="flex gap-4">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"/>
              </svg>
              <span>{{ vacancy.contract_type }}</span>
            </div>
            @if (vacancy.start_date) {
              <div class="flex gap-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"/>
                </svg>
                <span>{{ vacancy.start_date | date: 'shortDate' }}</span>
              </div>
            }
            @if (vacancy.salary) {
              <div class="flex gap-4">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                     stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round"
                        d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"/>
                </svg>
                <span>{{ vacancy.salary | currency }}</span>
              </div>
            }
            <div class="flex gap-4">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                   stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                      d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z"/>
              </svg>
              <span>{{ EXPERIENCES[vacancy.experience] }}</span>
            </div>
          </div>
        }
      </div>
      <button appHoverGradient
              [ngClass]="{'invisible': showForm()}"
              class="big-btn w-fit py-4 text-md mt-0 self-end md:self-auto"
              (click)="displayForm()"
              (keyup.enter)="emulateClick($event)">
        {{ 'candidate' | translate }}
      </button>
    </div>

  </div>
  <div class="layout pt-8 pb-16 bg-opacity-10 bg-bleuCaliceo-300">
    @if (showForm() && form; as form) {
      <form [formGroup]="form"
            class="w-full md:grid grid-cols-2 gap-x-20 gap-y-8">
        <div>
          <div class="flex md:flex-row flex-col gap-4 mb-4">
            <div class="w-full md:w-1/2 mb-6 md:mb-0">
              <label class="text-gray-500 text-md font-semibold pb-2 block" for="firstName">
                {{ 'firstName' | translate }} <span class="text-red-600">*</span>
              </label>
              <input
                id="firstName"
                formControlName="firstname"
                class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                type="text">
            </div>
            <div class="w-full md:w-1/2">
              <label class="text-gray-500 text-md font-semibold pb-2 block" for="lastName">
                {{ 'lastName' | translate }} <span class="text-red-600">*</span>
              </label>
              <input
                id="lastName"
                formControlName="lastname"
                class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                type="text">
            </div>
          </div>
          <div class="flex flex-wrap mb-4">
            <div class="w-full">
              <label class="text-gray-500 text-md font-semibold pb-2 block" for="email">
                {{ 'email' | translate }} <span class="text-red-600">*</span>
              </label>
              <input
                id="email"
                formControlName="email"
                class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                type="email">
            </div>
          </div>
          <div class="flex flex-wrap mb-4">
            <div class="w-full">
              <label for="phone" class="text-gray-500 text-md font-semibold pb-2 block">
                {{ 'yourMobilePhone' | translate }}
              </label>
              <input
                id="phone"
                formControlName="phone"
                class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                type="text">
              @if (form.get('phone')?.errors?.['pattern']) {
                <p class="peer-invalid:visible text-red-600 text-xs mt-2">
                  {{ 'phoneRules' | translate }}
                </p>
              }
            </div>
          </div>
        </div>
        <div>
          <div class="flex flex-wrap mb-4">
            <div class="w-full">
              <label for="cv" class="text-gray-500 text-md font-semibold pb-2 block">{{ 'cv' | translate }}<span
                class="text-red-600">*</span></label>
              <div
                appFileDrop (dropFile)="onCvChanged($event)"
                class="mt-2 flex justify-center rounded-lg border border-dashed border-gray-700 px-6 py-10 md:py-24">
                <div class="text-center">
                  @if (resumeControl.value; as file) {
                    {{ file.fileName }}
                  } @else {
                    <svg class="mx-auto size-12 text-gray-300" viewBox="0 0 24 24" fill="currentColor"
                         aria-hidden="true"
                         data-slot="icon">
                      <path fill-rule="evenodd"
                            d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z"
                            clip-rule="evenodd"/>
                    </svg>
                  }
                  <div class="mt-4 flex text-sm/6 text-gray-600">
                    <label for="file-upload"
                           class="relative cursor-pointer rounded-md  font-semibold text-gray-700 focus-within:ring-2 focus-within:ring-bleuCaliceo-300 focus-within:ring-offset-2 focus-within:outline-hidden hover:text-bleuCaliceo-500">
                      <span>{{ 'uploadCV' | translate }}</span>
                      <input id="file-upload" name="file-upload" accept="application/pdf"
                             (change)="onFileChanged($event)"
                             type="file"
                             class="sr-only">
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        @for (question of questions(); track question.id) {
          <div class="col-span-2 flex flex-col md:flex-row gap-8">
            <p class="text-gray-500 text-md font-semibold block">{{ question.text }}</p>
            <div class="flex flex-wrap gap-4 items-center">
              @for (value of question.values; track value) {
                <label
                  [for]="value + '-' + question.id"
                  class="font-semibold rounded-full py-2 px-6 hover:bg-bleuCaliceo-300 hover:text-white cursor-pointer"
                  [ngClass]="question.formGroup.get('value')!.value === value ? 'bg-bleuCaliceo-300 text-white' : 'bg-white'">
                  <input type="radio" [value]="value" class="sr-only"
                         [formControl]="questionValueFormControl(question.formGroup)"
                         [id]="value + '-' + question.id">
                  <span>{{ value }}</span>
                </label>
              }
            </div>
          </div>
        }
        <div>
          <label class="text-gray-500 text-md font-semibold pb-2 block" for="motivation">
            {{ 'motivation' | translate }}
          </label>
          <div class="mt-2">
            <textarea name="motivation" id="motivation" rows="3"
                      formControlName="comment"
                      class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
            ></textarea>
          </div>
        </div>
        <div>
          <h2 class="text-gray-500 text-md font-semibold pb-2 mb-4 block">
            {{ 'socialVacancy' | translate }}
          </h2>
          <div formGroupName="urls" class="flex flex-col gap-4 mb-4">
            <div class="w-full">
              <label class="text-gray-500 text-md font-semibold pb-2 block" for="linkedin">
                {{ 'linkedInVacancy' | translate }}
              </label>
              <input
                id="linkedIn"
                formControlName="linkedin"
                class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                type="text">
            </div>
            <div class="w-full">
              <label class="text-gray-500 text-md font-semibold pb-2 block" for="otherLink">
                {{ 'otherLinkVacancy' | translate }}
              </label>
              <input
                id="otherLink"
                formControlName="other"
                class="appearance-none block w-full text-gray-700 border border-gray-200 rounded-lg py-4 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500 disabled:bg-gray-100"
                type="text">
            </div>
          </div>
        </div>
        <div class="col-span-2">
          <div class="flex flex-wrap mb-4">
            <div class="w-full">
              <input id="accept-privacy"
                     type="checkbox"
                     formControlName="acceptPrivacy"
                     class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500">
              <label for="accept-privacy"
                     class="ms-2 text-sm font-medium text-gray-500">{{ 'acceptPrivacyFlatchr' | translate }}</label>
            </div>
          </div>
          <div class="flex flex-wrap mb-4">
            <div class="w-full">
              <input id="accept-cgu"
                     type="checkbox"
                     formControlName="acceptCGU"
                     class="w-4 h-4 border-gray-300 text-bleuCaliceo-300 focus:ring-0 disabled:text-gray-500">
              <label for="accept-cgu"
                     class="ms-2 text-sm font-medium text-gray-500"
                     [innerHtml]="'acceptCGUFlatchr' | translate"></label>
            </div>
          </div>
          <button type="button"
                  appHoverGradient
                  [disabled]="form.invalid"
                  [appProgressClick]="candidate"
                  class="big-btn flex justify-center items-center gap-2 mt-0">
            {{ 'validate' | translate }}
            <svg class="w-8 h-8" viewBox="0 0 24 24" fill="none" stroke="#ffffff">
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
              <g id="SVGRepo_iconCarrier">
                <g clip-path="url(#clip0_429_11249)">
                  <path d="M20 7.00018L10 17.0002L5 12.0002" stroke="#ffffff" stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"></path>
                </g>
                <defs>
                  <clipPath id="clip0_429_11249">
                    <rect width="24" height="24" fill="white"></rect>
                  </clipPath>
                </defs>
              </g>
            </svg>
          </button>
        </div>
      </form>
    } @else {
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <div class="col-span-1 lg:col-span-2">
          <h3 class="text-lg uppercase font-semibold text-bleuCaliceo-300 my-4">
            {{ 'vacancyDescription' | translate }}
          </h3>
          <p class="unreset career" [innerHtml]="vacancy.description"></p>
          @if (vacancy.benefits.length) {
            <h3 class="text-lg font-semibold underline">
              {{ 'vacancyBenefit' | translate }}
            </h3>
            <ul class="list-disc list-inside">
              @for (benefit of vacancy.benefits; track benefit.id) {
                <li>{{ benefit.name }}</li>
              }
            </ul>
          }
        </div>
        <div>
          <h3 class="text-lg uppercase font-semibold text-bleuCaliceo-300 my-4">
            {{ 'vacancyMissions' | translate }}
          </h3>
          <p class="unreset career" [innerHtml]="vacancy.mission"></p>
        </div>
        <div>
          <h3 class="text-lg uppercase font-semibold text-bleuCaliceo-300 my-4">
            {{ 'vacancyProfile' | translate }}
          </h3>
          <p class="unreset career" [innerHtml]="vacancy.profile"></p>
        </div>

      </div>
      <div class="flex justify-between items-center mt-4">
        <button class="text-sm flex gap-2 items-center" (click)="backToList()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
               stroke="currentColor" class="size-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"/>
          </svg>
          <span>{{ 'seeAllVacancies' | translate }}</span>
        </button>
        <button appHoverGradient
                class="big-btn w-fit py-4 text-md mt-0"
                (click)="displayForm()"
                (keyup.enter)="emulateClick($event)">
          {{ 'candidate' | translate }}
        </button>
      </div>
    }
  </div>
} @else {
  <div class="layout py-8">
    <h2 class="font-semibold text-3xl leading-tight mb-4 text-bleuCaliceo-300">{{ 'joinUs' | translate }}</h2>
    <div class="flex flex-col-reverse md:flex-row gap-2 md:gap-6 items-start">
      <div class="relative bg-beige rounded-lg mb-2 grow w-full">
        <svg aria-hidden="true" class="pointer-events-none absolute top-4 left-4 h-8 w-8 text-gray-700"
             fill="currentColor" viewBox="0 0 20 20">
          <path clip-rule="evenodd"
                d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                fill-rule="evenodd"/>
        </svg>
        <input #input (keyup)="filter.set(input.value.trim())" aria-controls="options"
               aria-expanded="false"
               class="h-16 w-full border-0 bg-transparent pl-16 pr-4 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-md"
               placeholder="{{'searchOffer'|translate}}..." role="combobox"
               type="search">
      </div>
      @if (spontaneous(); as spontaneous) {
        <button appHoverGradient
                class="big-btn w-full md:w-fit py-4 text-md mt-0 whitespace-nowrap"
                (click)="selectedVacancy.set(spontaneous)"
                (keyup.enter)="emulateClick($event)">
          {{ spontaneous.title }}
        </button>
      }
    </div>
    <div class="flex flex-col md:flex-row gap-2 md:gap-6 items-start">
      <div appAutoClose="always" class="relative mt-2 w-full grow">
        <button aria-labelledby="centerChoice"
                class="bg-gray-100 py-5 px-4 pr-10 md:px-7 hover:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none"
                type="button">
          <div class="flex items-center">
            <div class="w-12">
              <img alt="{{'caliceoLocation' | translate}}"
                   class="h-9 w-9 flex-shrink-0 m-auto" height="60" ngSrc="assets/icons/gray/location.svg"
                   width="60">
            </div>
            <div
              class="truncate text-gray-500 font-semibold text-lg ml-4 md:ml-6">
              <p class="font-semibold truncate text-xs"
                 id="centerChoice">{{ 'caliceoCenters' | translate }}</p>
              {{ selectedLocation() }}
            </div>
          </div>
          <div class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
            <img alt="" class="h-4 w-4" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
          </div>
        </button>
        <ul
          class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base
              shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
          @for (location of locations(); track location) {
            <li [attr.aria-selected]="selectedLocation() === location">
              <div class="flex items-center py-4 px-3 md:px-5 cursor-pointer text-gray-900 hover:bg-gray-100
                    relative select-none" (click)="selectedLocation.set(location)" role="button"
                   tabindex="0" onKeyUp (keyup.enter)="emulateClick($event)">
                    <span [ngClass]="selectedLocation() === location ? 'font-semibold' : 'font-normal'"
                          class="text-lg text-gray-500 ml-3 block truncate">
                      {{ location }}
                    </span>
              </div>
            </li>
          }
        </ul>
      </div>
      <div appAutoClose="always" class="relative mt-2 w-full grow">
        <button aria-labelledby="chooseContract"
                class="bg-gray-100 py-5 px-4 pr-10 md:px-7 hover:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none"
                type="button">
          <div class="flex items-center">
            <div class="w-12">
              <img alt="{{'chooseContract' | translate}}"
                   class="h-9 w-9 flex-shrink-0 m-auto" height="60" ngSrc="assets/icons/gray/contract.svg"
                   width="60">
            </div>
            <div
              class="truncate text-gray-500 font-semibold text-lg ml-4 md:ml-6">
              <p class="font-semibold truncate text-xs"
                 id="chooseContract">{{ 'chooseContract' | translate }}</p>
              {{ selectedContractType() }}
            </div>
          </div>
          <div class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
            <img alt="" class="h-4 w-4" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
          </div>
        </button>
        <ul
          class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base
              shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
          @for (contractType of contractTypes(); track contractType) {
            <li [attr.aria-selected]="selectedContractType() === contractType">
              <div class="flex items-center py-4 px-3 md:px-5 cursor-pointer text-gray-900 hover:bg-gray-100
                    relative select-none" (click)="selectedContractType.set(contractType)" role="button"
                   tabindex="0" onKeyUp (keyup.enter)="emulateClick($event)">
                    <span [ngClass]="selectedContractType() === contractType ? 'font-semibold' : 'font-normal'"
                          class="text-lg text-gray-500 ml-3 block truncate">
                      {{ contractType }}
                    </span>
              </div>
            </li>
          }
        </ul>
      </div>
      <div appAutoClose="always" class="relative mt-2 w-full grow">
        <button aria-labelledby="chooseJob"
                class="bg-gray-100 py-5 px-4 pr-10 md:px-7 hover:bg-gray-200 duration-200 cursor-pointer relative w-full rounded-md text-left text-gray-900 focus:outline-none"
                type="button">
          <div class="flex items-center">
            <div class="w-12">
              <img alt="{{'chooseJob' | translate}}"
                   class="h-9 w-9 flex-shrink-0 m-auto" height="60" ngSrc="assets/icons/gray/briefcase.svg"
                   width="60">
            </div>
            <div
              class="truncate text-gray-500 font-semibold text-lg ml-4 md:ml-6">
              <p class="font-semibold truncate text-xs"
                 id="chooseJob">{{ 'chooseJob' | translate }}</p>
              {{ selectedJob() }}
            </div>
          </div>
          <div class="pointer-events-none absolute inset-y-0 right-0 ml-3 flex items-center pr-6">
            <img alt="" class="h-4 w-4" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
          </div>
        </button>
        <ul
          class="hidden absolute z-10 mt-1 max-h-56 w-full overflow-auto rounded-md bg-white py-1 text-base
              shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
          @for (job of jobs(); track job) {
            <li [attr.aria-selected]="selectedJob() === job">
              <div class="flex items-center py-4 px-3 md:px-5 cursor-pointer text-gray-900 hover:bg-gray-100
                    relative select-none" (click)="selectedJob.set(job)" role="button"
                   tabindex="0" onKeyUp (keyup.enter)="emulateClick($event)">
                    <span [ngClass]="selectedJob() === job ? 'font-semibold' : 'font-normal'"
                          class="text-lg text-gray-500 ml-3 block truncate">
                      {{ job }}
                    </span>
              </div>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>
  <div class="bg-opacity-10 bg-bleuCaliceo-300">
    <div class="layout pt-8 pb-16">
      @if (displayedVacancies(); as vacancies) {
        <div class="grid md:grid-cols-2 lg:grid-cols-3 auto-rows-fr gap-x-4 gap-y-8 mt-4">
          @for (vacancy of vacancies; track vacancy.id) {
            <div role="button"
                 tabindex="0"
                 (click)="selectedVacancy.set(vacancy)"
                 (keyup.enter)="emulateClick($event)"
                 class="bg-white rounded-lg p-2 h-full flex flex-col cursor-pointer group">
              <div class="bg-white h-full rounded-lg p-6 group flex flex-col justify-between">
                <div class="w-full relative">
                  <div class="overflow-hidden relative rounded-lg aspect-[11/6]">
                    <img class="object-cover group-hover:scale-110 transition-all duration-500"
                         fill=""
                         [alt]=""
                         [ngSrc]="getImage(vacancy.metier)"
                         sizes="(max-width: 768) 100vw, (max-width: 1224) 25vw, 20vw">
                  </div>
                  @if (vacancy.tags[0]?.title; as title) {
                    <p
                      class="absolute top-14 left-2 uppercase py-2 px-4 bg-rougeCaliceo-300 text-white text-sm font-medium rounded">
                      {{ vacancy.contract_type }}
                    </p>
                    <p
                      class="absolute top-4 left-2 uppercase py-2 px-4 bg-bleuCaliceo-300 text-white text-sm font-medium rounded">
                      {{ title }}
                    </p>
                  } @else {
                    <p
                      class="absolute top-4 left-2 uppercase py-2 px-4 bg-rougeCaliceo-300 text-white text-sm font-medium rounded">
                      {{ vacancy.contract_type }}
                    </p>
                  }
                </div>
                <h3 class="text-bleuCaliceo-300 text-xl mt-7 uppercase font-semibold">
                  {{ vacancy.title }}
                </h3>
                <div class="text-sm mt-3 text-gray-500 grow flex flex-col">
                  <div class="flex gap-4">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" class="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"/>
                      <path stroke-linecap="round" stroke-linejoin="round"
                            d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"/>
                    </svg>
                    <span>{{ vacancy.address.locality }}
                      , {{ vacancy.address.postal_code }} {{ vacancy.address.country }}</span>
                  </div>
                  <div class="flex gap-4">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" class="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round"
                            d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"/>
                    </svg>
                    <span>{{ vacancy.contract_type }}</span>
                  </div>
                  @if (vacancy.start_date) {
                    <div class="flex gap-4">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                           stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"/>
                      </svg>
                      <span>{{ vacancy.start_date | date: 'shortDate' }}</span>
                    </div>
                  }
                  @if (vacancy.salary) {
                    <div class="flex gap-4">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                           stroke="currentColor" class="size-6">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M2.25 18.75a60.07 60.07 0 0 1 15.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 0 1 3 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 0 0-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 0 1-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 0 0 3 15h-.75M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm3 0h.008v.008H18V10.5Zm-12 0h.008v.008H6V10.5Z"/>
                      </svg>
                      <span>{{ vacancy.salary | currency }}</span>
                    </div>
                  }
                  <div class="flex gap-4">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                         stroke="currentColor" class="size-6">
                      <path stroke-linecap="round" stroke-linejoin="round"
                            d="M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z"/>
                    </svg>
                    <span>{{ EXPERIENCES[vacancy.experience] }}</span>
                  </div>
                </div>
                <div class="mt-7 flex justify-end items-center">
                  <div class="flex flex-row gap-3">
                    <button appHoverGradient
                            (click)="selectedVacancy.set(vacancy)"
                            (keyup.enter)="emulateClick($event)"
                            class="w-auto px-4 md:px-6 text-center text-sm">
                      {{ 'learnMore' | translate }} <span
                      class="sr-only">{{ vacancy.title }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          } @empty {
            @if (spontaneous(); as vacancy) {
              <div role="button"
                   tabindex="0"
                   (click)="selectedVacancy.set(vacancy)"
                   (keyup.enter)="emulateClick($event)"
                   class="bg-white rounded-lg p-2 h-full flex flex-col cursor-pointer group">
                <div class="bg-white h-full rounded-lg p-6 group flex flex-col justify-between">
                  <div class="w-full relative">
                    <div class="overflow-hidden relative rounded-lg aspect-[11/6]">
                      <img class="object-cover group-hover:scale-110 transition-all duration-500"
                           fill=""
                           [alt]=""
                           ngSrc="assets/images/placeholder.webp"
                           sizes="(max-width: 768) 100vw, (max-width: 1224) 25vw, 20vw">
                    </div>
                  </div>
                  <h3 class="text-bleuCaliceo-300 text-xl mt-7 uppercase font-semibold">
                    {{ vacancy.title }}
                  </h3>
                  <div class="mt-7 flex justify-end items-center">
                    <div class="flex flex-row gap-3">
                      <button appHoverGradient
                              (click)="selectedVacancy.set(vacancy)"
                              (keyup.enter)="emulateClick($event)"
                              class="w-auto px-4 md:px-6 text-center text-sm">
                        {{ 'learnMore' | translate }} <span
                        class="sr-only">{{ vacancy.title }}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          }
        </div>
      } @else {
        <div class='h-1 mt-10 w-full bg-gray-300 overflow-hidden'>
          <div class='progress w-full h-full bg-bleuCaliceo-300 left-right'></div>
        </div>
      }
    </div>
  </div>
}
